import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VExpansionPanels,{class:_vm.className,attrs:{"flat":""}},[_c(VExpansionPanel,[_c(VExpansionPanelHeader,[_c('app-text',{attrs:{"size":"body2","height":"height150"}},[_vm._v(" "+_vm._s(_vm.header)+" ")])],1),_c(VExpansionPanelContent,[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }